<template>

    <section class="form_admin-container">

        <div class="md_common-bl _padding-add">
            <div class="inner input-group">

                <!-- ここから Error -->
                <div class="item form_text">
                    <div class="input-row">
                        <input type="text" maxlength="250" id="example-error" class="_error">
                    </div>
                    <label for="example-error" class="_error"><span>テキストフィールド</span></label>
                </div>
                <!-- ここまで Error -->

                <!-- ここから Error -->
                <div class="item form_text">
                    <div class="input-row">
                        <input type="text" maxlength="250" id="example-error" class="_error _required">
                    </div>
                    <label for="example-error" class="_error _required"><span>テキストフィールド</span></label>
                </div>
                <!-- ここまで Error -->

            </div><!--/.inner-->
        </div><!--/.md-common-bl-->

    </section>

</template>


<script>
</script>
